<button *ngFor="let action of actions" [class]="action.class" (click)="action.action({})">
  <span translate>{{ action.label }}</span>
</button>
